import {useContext} from "react";
import {useQuery} from '@tanstack/react-query';
import UserContext from "@lib/contexts/userContext";
import {API_URLS, axiosRequest} from "@lib/axios";

/**
 * React Query wrapper for the Booth Topics query.
 */
const useBoothTopicsQuery = (session = null) => {
  const { authenticated } = useContext(UserContext);

  // Providing the lesson IDs already in use ensures they are returned even once they are deactivated.
  // Both the session's planned topic and the completed session's actual topic must stay selectable.
  const lessonIds = [session?.lesson?.id, session?.completed?.lesson_id]
    .filter((id, i, all) => !!id && all.indexOf(id) === i);
  const params = new URLSearchParams(lessonIds.map((id) => ['lesson', id])).toString();
  const query = params ? `?${params}` : '';

  return useQuery({
    queryKey: ['boothTopics', query],
    queryFn: async () => axiosRequest({
      method: 'GET',
      url: `${API_URLS.CURRICULA}/booth_topics${query}`
    }),
    enabled: authenticated,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useBoothTopicsQuery;
